import { NgClass } from '@angular/common'
import { Component, input, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { Section, TextWithImageContent } from 'app/_shared/interfaces/config'

@Component({
    selector: 'app-text-with-image',
    imports: [NgClass],
    templateUrl: './text-with-image.component.html',
    styleUrl: './text-with-image.component.scss'
})
export class TextWithImageComponent implements OnInit {
  section = input.required<Section<TextWithImageContent>>()
  trustedHtml: SafeHtml

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.trustedHtml = this.sanitizer.bypassSecurityTrustHtml(this.section()?.content?.text ?? '')
  }
}
